import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react"

import {
  Banner,
  Button, 
  // IconButton, Menu,
  MenuItem,
  Modal,
  RadioList,
  Switch,
  SegmentedTab,
  SegmentedTabs,
  SWAPLogo,
  SWAPSpace,
  TextField,
  Tooltip,
  Typography,
} from "@yosgo/swap-ui"

// import { DndProvider, useDrag, useDrop } from "react-dnd"
// import { XYCoord } from "dnd-core"
// import { HTML5Backend } from "react-dnd-html5-backend"
// import update from "immutability-helper"
// import type { TablerIconsKeyProps } from "./create/declare"
// import * as TablerIcons from "@tabler/icons"
// import Fade from "../../Common/Fade"
// import Classes from "@/utils/Theme"
import PathAndTitle from "@/utils/PathAndTitle"
import ProfileShareModal from "./ProfileShareModal"
import EditIconButton from "../ProjectComponents/Edit/EditIconButton"
import {
  debounce,
  Hidden,
  Link,
  makeStyles,
  Grid,
  useMediaQuery,
} from "@material-ui/core"
import LinkEditBlock from "./LinkEditBlock"
import { ImageToBase64 } from "@/utils/ImageToBase64"

import ImageUploader from "@/components/Common/ImageUploader"
import {
  createBatchMediaLinksFromSOHO,updateMediaLinkFromSOHO,
  // deleteMediaLinkFromSOHO,
} from "@/utils/appRequest/profile/link"
import InvisibleUploadImageInput from "@/components/Common/InvisibleUploadImageInput"
import { getProfileFromSOHO, updateMember,
} from "@/utils/appRequest/profile/member"
import MobileEditButton from "../ProjectComponents/MobileEditButton"
import { changeNewFreshChatCssStyle } from "@/components/Common/FreshChat"
import MobileShare from "@/utils/MobileShare"

import {
  GetSOHOTipsFromSOHO,
  UpdateSOHOTipFromSOHO,
} from "@/utils/AppRequest"
import { RESUME_HINT } from "@/values/announcementFlag"
import { AchievementProfileComponent } from '../Achievements/AchievementProfileComponent';
import { UploadCover } from './UploadCover';
import { getPersonalAchievementsFromSOHO, 
  toggleAchievementVisibleFromSOHO } from "@/utils/appRequest/achievements"
import { LinksBlock, LinksBlocksComponent} from "./LinkBlock"

import type { CaseTypeProps, SeniorityProps, WorkTypeProps } from "@/types/OptionTypes.d"
import type { AchievementProps } from "@/types/AchievementTypes.d"
import type { MemberDataProps } from "@/types/MemberTypes.d";
import type { LinkProps } from "@/types/LinkTypes.d"
import type { ContactProps } from "@/types/ContactTypes.d"

import CenterLoading from "../../Common/CenteredLoading";

import { 
  icon_close,
  icon_pic,
  icon_arrow,
  icon_edit,
  icon_check,
  icon_email,
  icon_facebook,
  icon_ig,
  icon_linkedin,
  icon_delete_big,
  icon_photo_small,
  icon_photo_blue,
  icon_email_blue,
  icon_avatar,
  icon_verified,
  icon_unVerified
} from "@/utils/icons/icons"

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "16px 24px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  achievementsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "16px",
    alignItems: "start",
    [theme.breakpoints.between(992, 1063)]: { // 調整 992px 到 1063px 的排版
      gridTemplateColumns: "repeat(2, 1fr)",  // 這段寬度區間每排顯示兩個成就
    },
    [theme.breakpoints.down('xs')]: { 
      gridTemplateColumns: "repeat(2, 1fr)", 
    },
  },
  achievementItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 16px 12px 24px",
    border: "1px solid #ccc",
    background : "#fff",
    borderRadius: "12px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  achievementItemOuter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "12px 16px",
    background: "#fff",
    borderRadius: "12px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  achievementImageWrapper: {
    position: "relative",
    width: "80px",  // Increased size to accommodate shadow
    height: "80px", // Increased size to accommodate shadow
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  achievementImage: {
    width: "60px",
    height: "60px",
    objectFit: "contain",
    borderRadius: "50%",
    position: "relative",
    zIndex: 2,
  },
  achievementShadow: {
    position: "absolute",
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    top: "35%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
    opacity: 0.8,
    transition: "all 0.3s ease",
  },
  operationShadow: {
    background: `
    radial-gradient(circle at 30% 30%, rgba(116, 194, 236, 0.8) 0%, rgba(116, 197, 228, 0.2) 60%, rgba(108, 127, 213, 0) 70%),
    radial-gradient(circle at 70% 70%, rgba(108, 127, 213, 0.8) 0%, rgba(108, 127, 213, 0.2) 60%, rgba(108, 127, 213, 0) 70%)
    `,
    filter: "blur(8px)",
    transform: "scale(0.5)",
    "&:hover": {
      transform: "scale(0.6)",
    },
  },
  paymentShadow: {
    background: `
    radial-gradient(circle at 30% 30%, rgba(231, 243, 120, 0.2) 0%, rgba(239, 228, 83, 0.05) 60%, rgba(247, 181, 44, 0) 70%),
    radial-gradient(circle at 70% 70%, rgba(238, 168, 28, 0.4) 0%, rgba(248, 175, 29, 0.1) 60%, rgba(247, 181, 44, 0) 70%)
    `,
    filter: "blur(8px)",
    transform: "scale(0.5)",
    "&:hover": {
      transform: "scale(0.6)",
    },
  },
  communityShadow: {
    background: `
    radial-gradient(circle at 30% 30%, rgba(246, 150, 230, 0.2) 0%, rgba(243, 135, 169, 0.05) 60%, rgba(247, 108, 69, 0) 70%),
    radial-gradient(circle at 70% 70%, rgba(245, 84, 39, 0.4) 0%, rgba(223, 87, 50, 0.1) 60%, rgba(247, 108, 69, 0) 70%)
    `,
    filter: "blur(8px)",
    transform: "scale(0.5)",
    "&:hover": {
      transform: "scale(0.6)",
    },
  },
  starContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "4px",
    marginTop: "4px",
  },
  focusVisible: {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

export async function handleImageToBase64(
  img: string,
  setImg: (img: string) => void
) {
  try {
    const result = await ImageToBase64(img)
    if (result) {
      setImg(`data:image/png;base64,${result}`)
    }
  } catch (error) {
    console.log(error)
  }
}

export interface ProfileProps {
  isFromGuest?: boolean
  isPreview?: boolean
  setIsPreview?: (isPreview: boolean) => void
  memberData: MemberDataProps
  setMemberData: (memberData: MemberDataProps) => void
  contact: ContactProps
  setContact: (contact: ContactProps) => void
  links: LinkProps[]
  setLinks: (links: React.SetStateAction<LinkProps[]>) => void
}

const Profile = ({
  isPreview,
  setIsPreview,
  memberData,
  setMemberData,
  contact,
  links,
  setLinks,
  isFromGuest,
}: ProfileProps) => {
  const [isOpenProfileShareModal, setIsOpenProfileShareModal] = useState(false)
  const [temporaryAvatar, setTemporaryAvatar] = useState("")
  const [avatarForBase64, setAvatarForBase64] = useState("")
  const [temporaryName, setTemporaryName] = useState("")
  const [temporaryIntroduction, setTemporaryIntroduction] = useState("")
  const [workType, setWorkType] = useState<"" | WorkTypeProps>("")
  const [caseType, setCaseType] = useState<CaseTypeProps | "">("")
  const [seniority, setSeniority] = useState<SeniorityProps | "">("")
  const [temporaryCaseType, setTemporaryCaseType] = useState<
    CaseTypeProps | ""
  >("")
  const [temporarySeniority, setTemporarySeniority] = useState<
    SeniorityProps | ""
  >("")
  const [temporaryContact, setTemporaryContact] = useState<ContactProps>({
    email: { id: 0, link: "" },
    facebook: { id: 0, link: "" },
    instagram: { id: 0, link: "" },
    linkedin: { id: 0, link: "" },
  })
  const [temporaryID, setTemporaryID] = useState<string>("")
  const [isOpenEditAchievementModal, setIsOpenEditAchievementModal] = useState<boolean>(false)
  const [isOpenDeleteCoverModal, setIsOpenDeleteCoverModal] = useState<boolean>(false)
  const [isOpenEditProfileModal, setIsOpenEditProfileModal] = useState<boolean>(false)
  const [isOpenEditIntroductionModal, setIsOpenEditIntroductionModal] = useState<boolean>(false)
  const [isOpenEditContactModal, setIsOpenEditContactModal] = useState<boolean>(false)
  const [isOpenCaseTypeModal, setIsOpenCaseTypeModal] = useState<boolean>(false)
  const [isOpenSeniorityModal, setIsOpenSeniorityModal] = useState<boolean>(false)
  const [avatarErr, setAvatarErr] = useState<boolean>(false)
  const [APILoading, setAPILoading] = useState<boolean>(false)
  const [IDErr, setIDErr] = useState<boolean>(false)
  const [isOpenAddLinkModal, setIsOpenAddLinkModal] = useState<boolean>(false)
  const [addLinkLoading, setAddLinkLoading] = useState<boolean>(false)
  const [newLink, setNewLink] = useState<LinkProps[]>([])
  const [temporaryCover, setTemporaryCover] = useState<string>("")
  const [coverForBase64, setCoverForBase64] = useState<string>("")
  const [uploadLoading, setUploadLoading] = useState<boolean>(false)
  const [isOpenEditCoverMobileModal, setIsOpenEditCoverMobileModal] = useState<boolean>(false)
  const [showBanner, setShowBanner] = useState<boolean>(false)
  const [hasVisibleAchievements, setHasVisibleAchievements] = useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const bio: any = useMemo(() => {
    if (memberData.bio) {
      return JSON.parse(memberData.bio)
    } else {
      return null
    }
  }, [memberData])

  const isDesktop = useMediaQuery("( min-width : 992px)")

  const checkAchievements = async () => {
    if (isFromGuest) {
      const visibleAchievements = memberData.achievements.some(achievement => 
        achievement.personal_achievement !== null
      );
      setHasVisibleAchievements(visibleAchievements);
    } else {
      try {
        const result = await getPersonalAchievementsFromSOHO();
        if (result && result.status === "200" && result.errors === null) {
          const hasAnyVisibleAchievements = result.payload.some((achievement: AchievementProps) => 
            achievement.personal_achievement !== null && 
            achievement.personal_achievement.is_visible
          );
          setHasVisibleAchievements(hasAnyVisibleAchievements);
        }
      } catch (error) {
        console.error("Error checking achievements:", error);
      }
    }
  };

  useEffect(() => {
    checkAchievements();
  }, [isFromGuest, memberData]);

  useEffect(() => {
    if (caseType) {
      setTemporaryCaseType(caseType)
    }
  }, [caseType])

  useEffect(() => {
    if (seniority) {
      setTemporarySeniority(seniority)
    }
  }, [seniority])

  useEffect(() => {
    changeNewFreshChatCssStyle({
      bottom: isPreview || isDesktop ? "20px" : "132px",
    })
  }, [isDesktop, isPreview])

  useEffect(() => {
    if (memberData) {
      setTemporaryID(memberData.personal_id)
      setTemporaryIntroduction(memberData.description)
      setTemporaryName(memberData.nick_name)
      setTemporaryAvatar(memberData.picture)
      setTemporaryCover(memberData.cover_picture)
    }
  }, [memberData])

  useEffect(() => {
    if (temporaryCover) {
      handleImageToBase64(temporaryCover, setCoverForBase64)
    } else {
      setCoverForBase64("")
    }
  }, [temporaryCover])

  useEffect(() => {
    if (bio) {
      setWorkType(bio.workType)
      setCaseType(bio.caseType)
      setSeniority(bio.seniority)
    }
  }, [bio])

  useEffect(() => {
    setTemporaryContact(contact)
  }, [contact])

  useEffect(() => {
    if (temporaryAvatar && temporaryAvatar.indexOf("https") !== -1) {
      handleImageToBase64(temporaryAvatar, setAvatarForBase64)
    } else {
      setAvatarForBase64("")
    }
  }, [temporaryAvatar])

  useEffect(() => {
    handleGetSOHOTipsFromSOHO()
  })

  const handleGetSOHOTipsFromSOHO = async () => {
    const GetSOHOTipsFromSOHOResult = await GetSOHOTipsFromSOHO()
    if (
      GetSOHOTipsFromSOHOResult &&
      GetSOHOTipsFromSOHOResult.errors === null
    ) {
      const data = GetSOHOTipsFromSOHOResult.payload
      const isOpen = !data.some(
        (item: { tip_id: string }) => item.tip_id === RESUME_HINT
      )
      setShowBanner(isOpen)
    }
  }

  const handleBannerClose = async () => {
    try {
      await UpdateSOHOTipFromSOHO({ tip_id: RESUME_HINT })
    } catch (error) {
      console.log("設定 Banner 顯示狀態出現錯誤，請聯繫客服")
    }
    setShowBanner(false)
  }

  const handleUpdateCover = async (cover: string) => {
    try {
      const result = await updateMember({
        cover_picture: cover,
      })
      if (result && result.errors === null) {
      } else {
        throw result.errors
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateMemberNameAndIDAndAvatar = async () => {
    try {
      setAPILoading(true)
      const result = await updateMember({
        nick_name:
          temporaryName !== memberData.nick_name ? temporaryName : undefined,
        picture:
          temporaryAvatar !== memberData.picture ? temporaryAvatar : undefined,
        personal_id:
          temporaryID !== memberData.personal_id ? temporaryID : undefined,
        bio:
          (!bio && (workType || caseType || seniority)) ||
          (bio &&
            (bio.workType !== workType ||
              bio.caseType !== caseType ||
              bio.seniority !== seniority))
            ? JSON.stringify({
                workType: workType,
                caseType: caseType,
                seniority: seniority,
              })
            : undefined,
      })
      setAPILoading(false)
      if (result && result.errors === null) {
        setMemberData({
          ...memberData,
          personal_id: temporaryID,
          nick_name: temporaryName,
          picture: temporaryAvatar,
          bio: JSON.stringify({
            workType: workType,
            caseType: caseType,
            seniority: seniority,
          }),
        })
        setIsOpenEditProfileModal(false)
      } else {
        throw result.errors
      }
    } catch (error) {
      setAPILoading(false)
      console.log(error)
    }
  }

  const handleUpdateMemberIntroduction = async () => {
    try {
      setAPILoading(true)
      const result = await updateMember({
        description:
          temporaryIntroduction !== memberData.description
            ? temporaryIntroduction
            : undefined,
      })
      setAPILoading(false)
      if (result && result.errors === null) {
        setMemberData({
          ...memberData,
          description: temporaryIntroduction,
        })
        setIsOpenEditIntroductionModal(false)
      } else {
        throw result.errors
      }
    } catch (error) {
      setAPILoading(false)
      console.log(error)
    }
  }

  const handleUpdateContact = async () => {
    try {
      setAPILoading(true)
      if (temporaryContact.email.link !== contact.email.link) {
        if (temporaryContact.email.id) {
          await updateMediaLinkFromSOHO({
            id: temporaryContact.email.id,
            title: "",
            link: temporaryContact.email.link,
            type: "email",
            index: 0,
            meta_picture: "",
          })
        } else {
          await createBatchMediaLinksFromSOHO({
            links: [
              {
                title: "",
                link: temporaryContact.email.link,
                type: "email",
                index: 0,
                meta_picture: "",
              },
            ],
          })
        }
      }
      if (temporaryContact.facebook.link !== contact.facebook.link) {
        if (temporaryContact.facebook.id) {
          await updateMediaLinkFromSOHO({
            id: temporaryContact.facebook.id,
            title: "",
            link: temporaryContact.facebook.link,
            type: "facebook",
            index: 0,
            meta_picture: "",
          })
        } else {
          await createBatchMediaLinksFromSOHO({
            links: [
              {
                title: "",
                link: temporaryContact.facebook.link,
                type: "facebook",
                index: 0,
                meta_picture: "",
              },
            ],
          })
        }
      }
      if (temporaryContact.instagram.link !== contact.instagram.link) {
        if (temporaryContact.instagram.id) {
          await updateMediaLinkFromSOHO({
            id: temporaryContact.instagram.id,
            title: "",
            link: temporaryContact.instagram.link,
            type: "instagram",
            index: 0,
            meta_picture: "",
          })
        } else {
          await createBatchMediaLinksFromSOHO({
            links: [
              {
                title: "",
                link: temporaryContact.instagram.link,
                type: "instagram",
                index: 0,
                meta_picture: "",
              },
            ],
          })
        }
      }
      if (temporaryContact.linkedin.link !== contact.linkedin.link) {
        if (temporaryContact.linkedin.id) {
          await updateMediaLinkFromSOHO({
            id: temporaryContact.linkedin.id,
            title: "",
            link: temporaryContact.linkedin.link,
            type: "linkedin",
            index: 0,
            meta_picture: "",
          })
        } else {
          await createBatchMediaLinksFromSOHO({
            links: [
              {
                title: "",
                link: temporaryContact.linkedin.link,
                type: "linkedin",
                index: 0,
                meta_picture: "",
              },
            ],
          })
        }
      }
      setAPILoading(false)
      setIsOpenEditContactModal(false)
      window.location.reload()
    } catch (error) {
      setAPILoading(false)
      console.log(error)
    }
  }

  const handleCheckID = async (id: string) => {
    try {
      if (id.match(/[^a-zA-Z0-9_\u4e00-\u9fa5]/)) {
        setIDErr(true)
      } else if (id === "") {
        setIDErr(false)
      } else {
        const result = await getProfileFromSOHO({
          checked: true,
          personal_id: id,
        })
        if (result && result.errors === null) {
          if (result.payload.existed) {
            setIDErr(true)
          } else {
            setIDErr(false)
          }
        } else {
          throw result.errors
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const resetProfile = () => {
    setIDErr(false)
    setTemporaryAvatar(memberData.picture)
    setTemporaryID(memberData.personal_id)
    setTemporaryName(memberData.nick_name)
    if (bio) {
      setCaseType(bio.caseType)
      setSeniority(bio.seniority)
      setWorkType(bio.workType)
    }
  }
  const resetIntroduction = () => {
    setTemporaryIntroduction(memberData.description)
  }
  const resetContact = () => {
    setTemporaryContact(contact)
  }

  const introductionRef = useRef(null)
  const handleChangeIntroduction = debounce(() => {
    const r: any = introductionRef.current
    if (r) {
      setTemporaryIntroduction(r.value)
    }
  }, 400)

  const IDRef = useRef(null)
  const handleChange = debounce(() => {
    const r: any = IDRef.current
    handleCheckID(r.value)
    setTemporaryID(r.value)
  }, 300)

  const resetLink = () => {
    setNewLink([])
  }

  const handleAddLink = async () => {
    try {
      setAddLinkLoading(true)
      const createLinksResult = await createBatchMediaLinksFromSOHO({
        links: [
          {
            title: newLink[0].title,
            meta_picture: newLink[0].meta_picture
              ? newLink[0].meta_picture
              : "",
            link: newLink[0].link,
            type: "normal",
            index: links.length,
          },
        ],
      })
      setAddLinkLoading(false)
      if (createLinksResult && createLinksResult.errors === null) {
        setAddLinkLoading(false)
        setIsOpenAddLinkModal(false)
        window.location.reload()
      } else {
        throw createLinksResult.errors
      }
    } catch (error) {
      setAddLinkLoading(false)
      console.log(error)
    }
  }

  const isNoLink: boolean = useMemo(() => {
    return (
      links.filter(
        (i) =>
          i.type !== "email" &&
          i.type !== "facebook" &&
          i.type !== "instagram" &&
          i.type !== "linkedin"
      ).length === 0
    )
  }, [links])

  const handleSaveComplete = async () => {
    await checkAchievements();
    setIsOpenEditAchievementModal(false);
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <>
      <Hidden mdDown>
        {!isPreview && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="secondary"
                size="small"
                onClick={() => {
                  if (setIsPreview) setIsPreview(true)
                }}
                style={{ marginRight: 8 }}
              >
                預覽接案履歷
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setIsOpenProfileShareModal(true)
                }}
              >
                分享接案履歷
              </Button>
            </div>
            <SWAPSpace />
          </>
        )}
      </Hidden>
      <Hidden mdDown>
        {showBanner && !isPreview ? (
          <>
            <Banner
              style={{
                width: "100%",
                position: "relative",
              }}
            >
              <Typography
                variant="caption2"
                color="black1000"
                style={{ paddingRight: 32 }}
              >
                建立好接案履歷，不只能管理你的所有社群、內容連結，更能有效提升在社團內接案的成功率！
              </Typography>
              <span
                style={{
                  position: "absolute",
                  right: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={handleBannerClose}
              >
                {icon_close}
              </span>
            </Banner>
            <SWAPSpace size={16} />
          </>
        ) : null}
      </Hidden>
      <UploadCover
        isPreview={isPreview}
        memberData={memberData}
        setMemberData={setMemberData}
        setIsOpenDeleteCoverModal={setIsOpenDeleteCoverModal}
        handleUpdateCover={handleUpdateCover}
        temporaryCover={temporaryCover}
        setTemporaryCover={setTemporaryCover}
        coverForBase64={coverForBase64}
        setCoverForBase64={setCoverForBase64}
        uploadLoading={uploadLoading}
        setUploadLoading={setUploadLoading}
        isMobile={!isDesktop}
      />
      <Hidden mdDown>
        <SWAPSpace size={24} />
        {(isFromGuest && isNoLink && !hasVisibleAchievements) || (isPreview && isNoLink && !hasVisibleAchievements) ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                minHeight: 590,
                backgroundColor: "#ffffff",
                borderRadius: 12,
                boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ececec",
                marginBottom: !isPreview ? undefined : 108,
              }}
            >
              <ProfileBlock
                isFromGuest={isFromGuest}
                isPreview={isPreview}
                memberData={memberData}
                contact={contact}
                temporaryAvatar={temporaryAvatar}
                avatarForBase64={avatarForBase64}
                temporaryName={temporaryName}
                temporaryIntroduction={temporaryIntroduction}
                workType={workType}
                caseType={caseType}
                seniority={seniority}
                temporaryContact={temporaryContact}
                temporaryID={temporaryID}
                bio={bio}
                setIsOpenEditProfileModal={setIsOpenEditProfileModal}
                setIsOpenEditIntroductionModal={setIsOpenEditIntroductionModal}
                setIsOpenEditContactModal={setIsOpenEditContactModal}
                setIsOpenEditAchievementModal={setIsOpenEditAchievementModal}
              />
            </div>
          </div>
        ) : (isFromGuest && isNoLink) || (isPreview && isNoLink) ? (
          <div
            style={{
              display: "grid",
              gap: 24,
              gridTemplateColumns: "1fr 1fr",
              gridAutoRows: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                backgroundColor: "#ffffff",
                borderRadius: 12,
                boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ececec",
                marginBottom: !isPreview ? undefined : 108,
                minHeight: 540,
                gridRow: "span 1",
              }}
            >
              <ProfileBlock
                isFromGuest={isFromGuest}
                isPreview={isPreview}
                memberData={memberData}
                contact={contact}
                temporaryAvatar={temporaryAvatar}
                avatarForBase64={avatarForBase64}
                temporaryName={temporaryName}
                temporaryIntroduction={temporaryIntroduction}
                workType={workType}
                caseType={caseType}
                seniority={seniority}
                temporaryContact={temporaryContact}
                temporaryID={temporaryID}
                bio={bio}
                setIsOpenEditProfileModal={setIsOpenEditProfileModal}
                setIsOpenEditIntroductionModal={setIsOpenEditIntroductionModal}
                setIsOpenEditContactModal={setIsOpenEditContactModal}
                setIsOpenEditAchievementModal={setIsOpenEditAchievementModal}
              />
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "#ffffff",
                borderRadius: 12,
                boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.1)",
                border: "1px solid #ececec",
                marginBottom: !isPreview ? undefined : 108,
                minHeight: 540,
                gridRow: "span 1",
              }}
            >
              <AchievementProfileComponent
                isFromGuest={isFromGuest || false}
                isPreview={isPreview || false}
                memberData={memberData}
                hasVisibleAchievements={hasVisibleAchievements}
                checkAchievements={checkAchievements}
              />
            </div>
          </div>
        ): (
          <div
            style={{
              display: "grid",
              gap: 24,
              gridTemplateColumns: hasVisibleAchievements ? "1fr 1.33fr" : "1fr 1fr",
              gridAutoRows: "auto",
            }}
          >
          {(() => {
            const items: Array<{
              children: React.ReactNode;
              style: {
                minHeight?: number; 
                gridRow?: string 
                marginBottom?: number | string;
              };
            }> = [
              {
                children: (
                  <ProfileBlock
                    isPreview={isPreview}
                    memberData={memberData}
                    contact={contact}
                    temporaryAvatar={temporaryAvatar}
                    avatarForBase64={avatarForBase64}
                    temporaryName={temporaryName}
                    temporaryIntroduction={temporaryIntroduction}
                    workType={workType}
                    caseType={caseType}
                    seniority={seniority}
                    temporaryContact={temporaryContact}
                    temporaryID={temporaryID}
                    bio={bio}
                    setIsOpenEditProfileModal={setIsOpenEditProfileModal}
                    setIsOpenEditIntroductionModal={setIsOpenEditIntroductionModal}
                    setIsOpenEditContactModal={setIsOpenEditContactModal}
                    setIsOpenEditAchievementModal={setIsOpenEditAchievementModal}
                  />
                ),
                style: {
                  minHeight: 540,
                  gridRow: "span 2",
                },
              },
              {
                children: (
                  <LinksBlock
                    isPreview={isPreview}
                    links={links}
                    setLinks={setLinks}
                    setIsOpenAddLinkModal={setIsOpenAddLinkModal}
                  />
                ),
                style: {
                  minHeight: 540,
                  gridRow: "span 1",
                },
              },
            ];
        
            // 渲染 AchievementProfileComponent，並檢查是否為 null
            const achievementComponent = (
              <AchievementProfileComponent
                isFromGuest={isFromGuest || false}
                isPreview={isPreview || false}
                memberData={memberData}
                hasVisibleAchievements={hasVisibleAchievements}
                checkAchievements={checkAchievements}
              />
            );
        
            if (!isPreview && !isFromGuest) {
              // 在後台無論有無成就都顯示 AchievementProfileComponent
              items.push({
                children: achievementComponent,
                style: {},
              });
            } else if (hasVisibleAchievements) {
              // 在前台有成就時顯示 AchievementProfileComponent
              items[1].style.marginBottom = 0;

              items.push({
                children: achievementComponent,
                style: {
                  gridRow: "span 1",
                },
              });
            } else {
              // 如果是前台且沒有成就，讓 LinksBlock 的 gridRow 是 span 2
              items[1].style.gridRow = "span 2";
              items[1].style.minHeight= 540;
            }
        
            return items.map((item, index) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  backgroundColor: "#ffffff",
                  borderRadius: 12,
                  boxShadow: "0px 6px 24px rgba(0, 0, 0, 0.1)",
                  border: "1px solid #ececec",
                  marginBottom: !isPreview ? undefined : 108,
                  ...item.style,
                }}
              >
                {item.children}
              </div>
            ));
          })()}
        </div>
      )}
      </Hidden>
      <Hidden lgUp>
        <ProfileMobileBlock
          memberData={memberData}
          contact={contact}
          temporaryAvatar={temporaryAvatar}
          avatarForBase64={avatarForBase64}
          temporaryName={temporaryName}
          temporaryIntroduction={temporaryIntroduction}
          workType={workType}
          caseType={caseType}
          seniority={seniority}
          temporaryContact={temporaryContact}
          temporaryID={temporaryID}
          bio={bio}
          links={links}
          setLinks={setLinks}
          setIsOpenEditProfileModal={setIsOpenEditProfileModal}
          setIsOpenEditIntroductionModal={setIsOpenEditIntroductionModal}
          setIsOpenEditContactModal={setIsOpenEditContactModal}
          setIsOpenAddLinkModal={setIsOpenAddLinkModal}
          setIsOpenEditCoverMobileModal={setIsOpenEditCoverMobileModal}
          setIsOpenEditAchievementModal={setIsOpenEditAchievementModal}
          isPreview={isPreview}
          isFromGuest={isFromGuest}
          showBanner={showBanner}
          handleBannerClose={handleBannerClose}
          hasVisibleAchievements={hasVisibleAchievements}
          checkAchievements={checkAchievements}
          refreshTriggerCount={refreshTrigger}
        />
      </Hidden>
      {/* Modals */}
      {/* 分享接案履歷 */}
      {!isPreview && (
        <ProfileShareModal
          open={isOpenProfileShareModal}
          onClose={() => {
            setIsOpenProfileShareModal(false)
          }}
          id={memberData.personal_id}
        />
      )}
      {/* 刪除封面 */}
      <Modal
        mobile={!isDesktop}
        fullWidth={!isDesktop}
        open={isOpenDeleteCoverModal}
        onClose={() => {
          setIsOpenDeleteCoverModal(false)
        }}
        maxWidth={isDesktop ? 480 : undefined}
        title="您確定要刪除封面照片？"
        primaryButton={{
          title: "刪除",
          onClick: () => {
            handleUpdateCover("")
            setMemberData({ ...memberData, cover_picture: "" })
            setIsOpenDeleteCoverModal(false)
          },
        }}
        secondaryButton={{
          title: "取消",
          onClick: () => {
            setIsOpenDeleteCoverModal(false)
          },
        }}
      />
      {/* 編輯個人資料 */}
      <Modal
        mobile={!isDesktop}
        fullWidth={!isDesktop}
        open={isOpenEditProfileModal}
        onClose={() => {
          resetProfile()
          setIsOpenEditProfileModal(false)
        }}
        title="編輯個人資料"
        maxWidth={isDesktop ? 640 : undefined}
        primaryButton={{
          title: "儲存",
          onClick: () => {
            handleUpdateMemberNameAndIDAndAvatar()
          },
          disabled: !temporaryName || APILoading || IDErr,
          loading: APILoading,
        }}
        secondaryButton={{
          title: "取消",
          onClick: () => {
            resetProfile()
            setIsOpenEditProfileModal(false)
          },
        }}
        children={
          <div
            style={{
              display: "flex",
              flexDirection: !isDesktop ? "column" : undefined,
              justifyContent: isDesktop ? "space-between" : undefined,
              alignItems: !isDesktop ? "center" : undefined,
            }}
          >
            <ImageUploader
              width={136}
              height={136}
              defaultIcon={icon_pic}
              disableWatermark
              uploadText="上傳頭貼"
              uploadingText="頭貼上傳中"
              uploadedText="頭貼已上傳"
              reUploadText="重新上傳頭貼"
              prefix={"imgavatar"}
              error={avatarErr}
              helperText={avatarErr ? "請記得上傳頭貼圖片哦！" : ""}
              img={temporaryAvatar}
              userId={memberData.id}
              userName={memberData.verified_name}
              handleClean={() => {
                setTemporaryAvatar("")
              }}
              handleChange={(Locations: string, base64: string) => {
                setTemporaryAvatar(Locations[0])
                setAvatarForBase64(base64)
                setAvatarErr(false)
              }}
              isImgPreviewCover
            />
            {!isDesktop && <SWAPSpace />}
            <div style={{ marginLeft: isDesktop ? 16 : 0, width: "100%" }}>
              <TextField
                fullWidth
                height={56}
                label="暱稱（必填）"
                InputLabelProps={{ shrink: true }}
                value={temporaryName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setTemporaryName(e.target.value)
                }}
              />
              <SWAPSpace />
              <TextField
                inputRef={IDRef}
                fullWidth
                height={56}
                label="個人ID（選填）"
                error={IDErr}
                helperText={
                  IDErr
                    ? temporaryID.match(/[^a-zA-Z0-9_\u4e00-\u9fa5]/)
                      ? "請勿使用 (_) 以外的符號"
                      : "此 ID 已被使用，請重新填寫！"
                    : "讓客戶更容易搜尋，快速前往您的接案履歷"
                }
                InputLabelProps={{ shrink: true }}
                defaultValue={temporaryID}
                onChange={handleChange}
              />
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "#ececec",
                  margin: "16px 0",
                }}
              />
              <Typography variant="title">工作型態</Typography>
              <SWAPSpace />
              <div
                style={{
                  display: "grid",
                  alignItems: "center",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 16,
                }}
              >
                <RadioList
                  width={isDesktop ? 212 : "100%"}
                  title="個人接案"
                  checked={workType === "personal"}
                  onClick={() => {
                    setWorkType("personal")
                  }}
                />
                <RadioList
                  width={isDesktop ? 212 : "100%"}
                  title="團隊接案"
                  checked={workType === "team"}
                  onClick={() => {
                    setWorkType("team")
                  }}
                />
              </div>
              <SWAPSpace />
              <div
                style={{
                  display: "grid",
                  alignItems: "center",
                  gridTemplateColumns: isDesktop ? "1fr 1fr" : undefined,
                  gridTemplateRows: !isDesktop ? "1fr 1fr" : undefined,
                  gap: 16,
                }}
              >
                <TextField
                  fullWidth={!isDesktop}
                  width={isDesktop ? 212 : undefined}
                  height={56}
                  label="接案類別"
                  value={caseType}
                  onChange={
                    isDesktop
                      ? (e: any) => {
                          setCaseType(e.target.value)
                        }
                      : undefined
                  }
                  select={isDesktop}
                  type={!isDesktop ? "button" : undefined}
                  onClick={
                    !isDesktop
                      ? () => {
                          setIsOpenCaseTypeModal(true)
                        }
                      : undefined
                  }
                  InputProps={
                    !isDesktop
                      ? {
                          endAdornment: icon_arrow,
                        }
                      : undefined
                  }
                >
                  {[
                    { label: "設計工作" },
                    { label: "程式開發" },
                    { label: "廣告行銷" },
                    { label: "影像工作" },
                    { label: "文字工作" },
                    { label: "顧問諮詢" },
                    { label: "語言翻譯" },
                    { label: "法律事務" },
                    { label: "財務會計" },
                    { label: "其他" },
                  ].map((item: any, i: number) => (
                    <MenuItem
                      key={i}
                      height={36}
                      width={240}
                      value={item.label}
                      style={{
                        backgroundColor:
                          caseType === item.label ? "white" : undefined,
                        opacity: caseType === item.label ? 1 : undefined,
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "nowrap",
                        color: caseType === item.label ? "#4862CC" : undefined,
                      }}
                      disabled={caseType === item.label}
                      iconChildren={caseType === item.label ? icon_check : null}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  fullWidth={!isDesktop}
                  width={isDesktop ? 212 : undefined}
                  height={56}
                  label="接案年資"
                  value={seniority}
                  onChange={
                    isDesktop
                      ? (e: any) => {
                          setSeniority(e.target.value)
                        }
                      : undefined
                  }
                  select={isDesktop}
                  type={!isDesktop ? "button" : undefined}
                  onClick={
                    !isDesktop
                      ? () => {
                          setIsOpenSeniorityModal(true)
                        }
                      : undefined
                  }
                  InputProps={
                    !isDesktop
                      ? {
                          endAdornment: icon_arrow,
                        }
                      : undefined
                  }
                >
                  {[
                    { label: "小於 1 年" },
                    { label: "1 ～ 2 年" },
                    { label: "2 ～ 4 年" },
                    { label: "4 ～ 6 年" },
                    { label: "6 年以上" },
                  ].map((item: any, i: number) => (
                    <MenuItem
                      key={i}
                      height={36}
                      width={240}
                      value={item.label}
                      style={{
                        backgroundColor:
                          seniority === item.label ? "white" : undefined,
                        opacity: seniority === item.label ? 1 : undefined,
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "nowrap",
                        color: seniority === item.label ? "#4862CC" : undefined,
                      }}
                      disabled={seniority === item.label}
                      iconChildren={
                        seniority === item.label ? icon_check : null
                      }
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
          </div>
        }
      />
      {/* 接案類別 */}
      <Modal
        mobile
        fullWidth
        open={isOpenCaseTypeModal}
        onClose={() => {
          setIsOpenCaseTypeModal(false)
          setIsOpenEditProfileModal(true)
          setTemporaryCaseType(caseType)
        }}
        title="接案類別"
        primaryButton={{
          title: "確認",
          onClick: () => {
            setCaseType(temporaryCaseType)
            setIsOpenEditProfileModal(true)
            setIsOpenCaseTypeModal(false)
          },
          variant: "secondary",
        }}
        children={
          <>
            {[
              "設計工作",
              "程式開發",
              "廣告行銷",
              "影像工作",
              "文字工作",
              "顧問諮詢",
              "語言翻譯",
              "法律事務",
              "財務會計",
              "其他",
            ].map((i: any) => (
              <RadioList
                key={i}
                width="100%"
                title={i}
                checked={temporaryCaseType === i}
                onClick={() => {
                  setTemporaryCaseType(i)
                }}
                style={{ marginBottom: i !== "其他" ? 8 : 0 }}
              />
            ))}
          </>
        }
      />
      {/* 接案年資 */}
      <Modal
        mobile
        fullWidth
        open={isOpenSeniorityModal}
        onClose={() => {
          setIsOpenSeniorityModal(false)
          setIsOpenEditProfileModal(true)
          setTemporarySeniority(seniority)
        }}
        title="接案年資"
        primaryButton={{
          title: "確認",
          onClick: () => {
            setSeniority(temporarySeniority)
            setIsOpenEditProfileModal(true)
            setIsOpenSeniorityModal(false)
          },
          variant: "secondary",
        }}
        children={
          <>
            {[
              "小於 1 年",
              "1 ～ 2 年",
              "2 ～ 4 年",
              "4 ～ 6 年",
              "6 年以上",
            ].map((i: any) => (
              <RadioList
                key={i}
                width="100%"
                title={i}
                checked={temporarySeniority === i}
                onClick={() => {
                  setTemporarySeniority(i)
                }}
                style={{ marginBottom: i !== "6 年以上" ? 8 : 0 }}
              />
            ))}
          </>
        }
      />

      <RenderAchievementModal 
        isMobile={!isDesktop}
        isFullWidth={!isDesktop}
        isOpen={isOpenEditAchievementModal}
        onCloseModal={() => setIsOpenEditAchievementModal(false)}
        onSaveComplete={handleSaveComplete}
      />
      {/* 編輯關於我 */}
      <Modal
        mobile={!isDesktop}
        fullWidth={!isDesktop}
        open={isOpenEditIntroductionModal}
        onClose={() => {
          resetIntroduction()
          setIsOpenEditIntroductionModal(false)
        }}
        maxWidth={isDesktop ? 640 : undefined}
        title="編輯關於我"
        primaryButton={{
          title: "儲存",
          onClick: () => {
            handleUpdateMemberIntroduction()
          },
          disabled: APILoading,
          loading: APILoading,
        }}
        secondaryButton={{
          title: "取消",
          onClick: () => {
            resetIntroduction()
            setIsOpenEditIntroductionModal(false)
          },
        }}
        children={
          <>
            <TextField
              inputRef={introductionRef}
              fullWidth
              height={103}
              multiline
              rows={3}
              label="您的介紹"
              defaultValue={temporaryIntroduction}
              InputLabelProps={{ shrink: true }}
              onChange={handleChangeIntroduction}
            />
          </>
        }
      />
      {/* 編輯聯繫方式 */}
      <Modal
        mobile={!isDesktop}
        fullWidth={!isDesktop}
        open={isOpenEditContactModal}
        onClose={() => {
          resetContact()
          setIsOpenEditContactModal(false)
        }}
        maxWidth={isDesktop ? 640 : undefined}
        title="編輯聯繫方式"
        primaryButton={{
          title: "儲存",
          onClick: () => {
            handleUpdateContact()
          },
          disabled: APILoading,
          loading: APILoading,
        }}
        secondaryButton={{
          title: "取消",
          onClick: () => {
            resetContact()
            setIsOpenEditContactModal(false)
          },
        }}
        children={
          <div
            style={{
              display: "grid",
              gap: 16,
              alignItems: "center",
              gridTemplateColumns: "56px 1fr",
              gridTemplateRows: "1fr 1fr 1fr 1fr",
            }}
          >
            {[
              { id: "email", placeholder: "Email", icon: icon_email },
              { id: "facebook", placeholder: "Facebook", icon: icon_facebook },
              { id: "instagram", placeholder: "Instagram", icon: icon_ig },
              { id: "linkedin", placeholder: "Linkedin", icon: icon_linkedin },
            ].map((i) => (
              <React.Fragment key={i.id}>
                <div
                  style={{
                    width: 56,
                    height: 56,
                    backgroundColor: "#f6f6f6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 8,
                  }}
                >
                  {i.icon}
                </div>
                <TextField
                  fullWidth
                  height={56}
                  value={
                    temporaryContact[
                      `${i.id}` as
                        | "email"
                        | "facebook"
                        | "instagram"
                        | "linkedin"
                    ].link
                  }
                  type={i.id === "email" ? "email" : "url"}
                  placeholder={`請填入 ${i.placeholder} 的完整${
                    i.id === "email" ? "信箱" : "網址"
                  }`}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setTemporaryContact({
                      ...temporaryContact,
                      [`${i.id}` as
                        | "email"
                        | "facebook"
                        | "instagram"
                        | "linkedin"]: {
                        id: temporaryContact[
                          `${i.id}` as
                            | "email"
                            | "facebook"
                            | "instagram"
                            | "linkedin"
                        ].id,
                        link: e.target.value,
                      },
                    })
                  }}
                />
              </React.Fragment>
            ))}
          </div>
        }
      />
      {/* 新增連結 */}
      <Modal
        mobile={!isDesktop}
        fullWidth={!isDesktop}
        open={isOpenAddLinkModal}
        onClose={() => {
          resetLink()
          setIsOpenAddLinkModal(false)
        }}
        maxWidth={isDesktop ? 640 : undefined}
        title="新增連結"
        primaryButton={{
          title: "新增",
          onClick: handleAddLink,
          disabled: !newLink[0]?.title || !newLink[0]?.link || addLinkLoading,
          loading: addLinkLoading,
        }}
        secondaryButton={{
          title: "取消",
          onClick: () => {
            resetLink()
            setIsOpenAddLinkModal(false)
          },
        }}
        children={
          <LinkEditBlock
            links={newLink}
            setLinks={setNewLink}
            blockIndex={0}
            isAddLink
            isMobile={!isDesktop}
          />
        }
      />

      {/* setIsOpenEditAchievementModal */}


      {/* 封面選項 */}
      <Modal
        mobile
        fullWidth
        open={isOpenEditCoverMobileModal}
        onClose={() => {
          setIsOpenEditCoverMobileModal(false)
        }}
        title="封面選項"
        primaryButton={{
          title: "取消",
          onClick: () => {
            setIsOpenEditCoverMobileModal(false)
          },
          variant: "secondary",
        }}
        children={
          <>
            {[
              {
                icon: icon_photo_small,
                text: "從照片圖庫",
                onClick: () => {},
              },
              // {
              //   icon: icon_camera,
              //   text: "從相機拍照",
              //   onClick: () => {
              //     setIsOpenEditCoverMobileModal(false)
              //   },
              // },
              {
                icon: icon_delete_big,
                text: "刪除照片",
                onClick: () => {
                  setIsOpenDeleteCoverModal(true)
                  setIsOpenEditCoverMobileModal(false)
                },
              },
            ].map((i, index) => (
              <div
                key={index}
                style={{
                  width: "100%",
                  height: 54,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 16px",
                  borderRadius: 8,
                  border: "1px solid #cccccc",
                  backgroundColor: "#ffffff",
                  marginBottom: i.text !== "刪除照片" ? 8 : 0,
                  position: "relative",
                }}
                onClick={i.onClick}
              >
                {index === 0 && (
                  <InvisibleUploadImageInput
                    width={"100%"}
                    height={"100%"}
                    beforeUploadFunction={() => {
                      setUploadLoading(true)
                    }}
                    afterUploadFunction={(r, base64) => {
                      setTemporaryCover(r)
                      setCoverForBase64(base64)
                      setMemberData({ ...memberData, cover_picture: r })
                      handleUpdateCover(r)
                      setUploadLoading(false)
                      setIsOpenEditCoverMobileModal(false)
                    }}
                  />
                )}
                {i.icon}{" "}
                <Typography variant="title" style={{ marginLeft: 8 }}>
                  {i.text}
                </Typography>
              </div>
            ))}
          </>
        }
      />
    </>
  )
}
export interface ProfileBlockProps {
  isPreview?: boolean
  memberData: MemberDataProps
  contact: ContactProps
  temporaryAvatar: string
  avatarForBase64: string
  temporaryName: string
  temporaryIntroduction: string
  workType: "" | WorkTypeProps
  caseType: CaseTypeProps | ""
  seniority: SeniorityProps | ""
  temporaryContact: ContactProps
  temporaryID: string
  bio: {
    workType: "" | WorkTypeProps
    caseType: CaseTypeProps | ""
    seniority: SeniorityProps | ""
  } | null
  setIsOpenEditProfileModal: (isOpen: boolean) => void
  setIsOpenEditIntroductionModal: (isOpen: boolean) => void
  setIsOpenEditContactModal: (isOpen: boolean) => void
  setIsOpenEditAchievementModal: (isOpen: boolean) => void
  isFromGuest?: boolean
}

const ProfileBlock = ({
  isPreview,
  memberData,
  temporaryAvatar,
  avatarForBase64,
  temporaryName,
  temporaryIntroduction,
  workType,
  caseType,
  seniority,
  temporaryContact,
  setIsOpenEditProfileModal,
  setIsOpenEditIntroductionModal,
  setIsOpenEditContactModal,
  // setIsOpenEditAchievementModal,
  isFromGuest,
}: ProfileBlockProps) => {
  return (
    <>
      <div
        style={{
          padding: 40,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                avatar={temporaryAvatar}
                avatarForBase64={avatarForBase64}
                memberData={memberData}
              />
              <div style={{ marginLeft: 16 }}>
                <Name name={temporaryName} />
                <SWAPSpace size={10} />
                <Chip
                  workType={workType}
                  caseType={caseType}
                  seniority={seniority}
                />
              </div>
            </div>
            <div style={{ marginTop: 22 }}>
              <VerifyIcon
                verifiedState={memberData.verified_state}
                isPreview={isPreview}
              />
            </div>
          </div>
          {!isPreview && (
            <>
              <SWAPSpace />
              <Button
                fullWidth
                variant="secondary"
                size="small"
                onClick={() => {
                  setIsOpenEditProfileModal(true)
                }}
              >
                編輯個人資料
              </Button>
            </>
          )}
          {!(isFromGuest && !memberData.description) && (
            <>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "#ececec",
                  margin: "24px 0",
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="h6">
                  關於我
                </Typography>
                {!isPreview && (
                  <EditIconButton
                    borderRadius={8}
                    width={40}
                    height={40}
                    icon={icon_edit}
                    onClick={() => {
                      setIsOpenEditIntroductionModal(true)
                    }}
                  />
                )}
              </div>
              <SWAPSpace />
              <Introduction introduction={temporaryIntroduction} />
            </>
          )}
          {!(
            isFromGuest &&
            !temporaryContact.email.link &&
            !temporaryContact.facebook.link &&
            !temporaryContact.instagram.link &&
            !temporaryContact.linkedin.link
          ) && (
            <>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "#ececec",
                  margin: "24px 0",
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="h6">聯繫方式</Typography>
                {!isPreview && (
                  <EditIconButton
                    borderRadius={8}
                    width={40}
                    height={40}
                    icon={icon_edit}
                    onClick={() => {
                      setIsOpenEditContactModal(true)
                    }}
                  />
                )}
              </div>
              <SWAPSpace />
              <ContactComponent contact={temporaryContact} />
            </>
          )}
        </div>
        <div>
          <div
            style={{
              width: "100%",
              height: 1,
              backgroundColor: "#ececec",
              margin: "24px 0",
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: 24,
            }}
          >
            <Link href="/">
              <SWAPLogo />
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export interface ProfileMobileBlock {
  memberData: MemberDataProps
  contact: ContactProps
  temporaryAvatar: string
  avatarForBase64: string
  temporaryName: string
  temporaryIntroduction: string
  workType: "" | WorkTypeProps
  caseType: CaseTypeProps | ""
  seniority: SeniorityProps | ""
  temporaryContact: ContactProps
  temporaryID: string
  bio: {
    workType: "" | WorkTypeProps
    caseType: CaseTypeProps | ""
    seniority: SeniorityProps | ""
  } | null
  links: LinkProps[]
  setLinks: (links: React.SetStateAction<LinkProps[]>) => void
  setIsOpenEditProfileModal: (isOpen: boolean) => void
  setIsOpenEditIntroductionModal: (isOpen: boolean) => void
  setIsOpenEditContactModal: (isOpen: boolean) => void
  setIsOpenAddLinkModal: (isOpen: boolean) => void
  setIsOpenEditCoverMobileModal: (isOpen: boolean) => void
  setIsOpenEditAchievementModal: (isOpen: boolean) => void
  isPreview?: boolean
  isFromGuest?: boolean
  showBanner: boolean
  handleBannerClose: () => void
  hasVisibleAchievements: boolean
  checkAchievements: () => Promise<void>
  refreshTriggerCount: number
}

const ProfileMobileBlock = ({
  isFromGuest,
  isPreview,
  memberData,
  temporaryAvatar,
  avatarForBase64,
  temporaryName,
  temporaryIntroduction,
  workType,
  caseType,
  seniority,
  temporaryContact,
  temporaryID,
  links,
  setLinks,
  setIsOpenEditProfileModal,
  setIsOpenEditIntroductionModal,
  setIsOpenEditContactModal,
  setIsOpenAddLinkModal,
  setIsOpenEditCoverMobileModal,
  setIsOpenEditAchievementModal,
  showBanner,
  handleBannerClose,
  hasVisibleAchievements,
  checkAchievements,
  refreshTriggerCount
}: ProfileMobileBlock) => {

  const [tabValue, setTabValue] = useState<number>(0);

  const isDesktop = useMediaQuery("( min-width : 992px)")

  return (
    <>
      {!isPreview && (
        <MobileLayout
          tabValue={tabValue}
          id={temporaryID}
          setIsOpenAddLinkModal={setIsOpenAddLinkModal}
          setIsOpenEditIntroductionModal={setIsOpenEditIntroductionModal}
          setIsOpenEditContactModal={setIsOpenEditContactModal}
          setIsOpenEditProfileModal={setIsOpenEditProfileModal}
          setIsOpenEditCoverMobileModal={setIsOpenEditCoverMobileModal}
          setIsOpenEditAchievementModal={setIsOpenEditAchievementModal}
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          backgroundColor: "#ffffff",
          minHeight: "calc(100vh - 190px)",
          padding: "0 8px 96px 8px",
        }}
      >
        <div
          style={{
            width: 108,
            height: 108,
            position: "absolute",
            top: -70,
            zIndex: 2,
          }}
        >
          <Avatar
            avatar={temporaryAvatar}
            avatarForBase64={avatarForBase64}
            memberData={memberData}
          />
        </div>
        <SWAPSpace size={54} /> 
        <div
          style={{
            width: "fit-content",
            height: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            margin: "0 32px",
          }}
        >
          <Name name={temporaryName} isMobile />
          <div
            style={{
              width: "fit-content",
              height: "fit-content",
              position: "absolute",
              right: -16,
              zIndex: 2,
            }}
          >
            <VerifyIcon verifiedState={memberData.verified_state} isMobile />
          </div>
        </div>
        <SWAPSpace />
        <Chip
          workType={workType}
          caseType={caseType}
          seniority={seniority}
          isMobile
        />
        <SWAPSpace />
        <ContactComponent contact={temporaryContact} isMobile />
        {showBanner && !isPreview ? (
          <>
            <SWAPSpace size={16} />
            <Banner
              style={{
                width: "100%",
                position: "relative",
              }}
            >
              <Typography
                variant="caption2"
                color="black1000"
                style={{ paddingRight: 32 }}
              >
                建立好接案履歷，不只能管理你的所有社群、內容連結，更能有效提升在社團內接案的成功率！
              </Typography>
              <span
                style={{
                  position: "absolute",
                  right: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={handleBannerClose}
              >
                {icon_close}
              </span>
            </Banner>
          </>
        ) : null}
        <SWAPSpace size={showBanner ? 16 : 24} />
        <div
          style={{
            width: "100%",
            padding: "0 8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <SegmentedTabs
            slide
            value={tabValue}
            width="100%"
            style={{ maxWidth: 528 }}
          >
            <SegmentedTab
              flex={1}
              fullWidth
              label="我的連結"
              onClick={() => {
                setTabValue(0)
              }}
            />
            <SegmentedTab
              flex={1}
              fullWidth
              label="關於我"
              onClick={() => {
                setTabValue(1)
              }}
            />
            { ((!isPreview && !isFromGuest ) || hasVisibleAchievements) && (
              <SegmentedTab
                flex={1}
                fullWidth 
                label="我的成就"
                onClick={() => {
                  setTabValue(2)
                }}
              />
             )} 
          </SegmentedTabs>
        </div>
        <SWAPSpace />
        {tabValue === 0 ? (
          <div style={{ width: "100%", maxWidth: 528, padding: "0 8px" }}>
            <LinksBlocksComponent
              links={links}
              setLinks={setLinks}
              isMobile
              isPreview={isPreview}
              isFromGuest={isFromGuest}
            />
          </div>
        ) : tabValue === 2 ? (
          <div style={{ width: "100%", maxWidth: 528, padding: "0 8px" }}>
              <AchievementProfileComponent 
                isFromGuest={isFromGuest || false} 
                isPreview={isPreview || false} 
                memberData={memberData}
                hasVisibleAchievements={hasVisibleAchievements}
                checkAchievements={checkAchievements}
                goRefreshTrigger={refreshTriggerCount}
                isDesktop={isDesktop}
              />
          </div>
        )
        : (
          <div
            style={{
              width: "100%",
              padding: "0 16px",
              maxWidth: 528,
              minHeight: 64,
            }}
          >
            <SWAPSpace />
            <Introduction
              introduction={temporaryIntroduction}
              isFromGuest={isFromGuest}
            />
          </div>
        )}
        <SWAPSpace size={32} />
        <div style={{ width: "100%", height: "100%", padding: "0 8px" }}>
          <div
            style={{
              width: "100%",
              height: 1,
              backgroundColor: "#ececec",
            }}
          ></div>
        </div>
        <SWAPSpace size={48} />
        <Link href="/">
          <SWAPLogo />
        </Link>
      </div>
    </>
  )
}
export interface MobileLayoutProps {
  tabValue: number
  id: string
  setIsOpenEditIntroductionModal: (isOpen: boolean) => void
  setIsOpenAddLinkModal: (isOpen: boolean) => void
  setIsOpenEditContactModal: (isOpen: boolean) => void
  setIsOpenEditProfileModal: (isOpen: boolean) => void
  setIsOpenEditCoverMobileModal: (isOpen: boolean) => void
  setIsOpenEditAchievementModal: (isOpen: boolean) => void
}

const MobileLayout = ({
  tabValue,
  id,
  setIsOpenEditIntroductionModal,
  setIsOpenAddLinkModal,
  setIsOpenEditContactModal,
  setIsOpenEditProfileModal,
  setIsOpenEditCoverMobileModal,
  setIsOpenEditAchievementModal
}: MobileLayoutProps) => {
  const [isOpenMobileEditButton, setIsOpenMobileEditButton] = useState(false)
  return (
    <>
      <div
        style={{
          width: "100%",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          bottom: 0,
          left: 0,
          padding: "0 16px",
          zIndex: 100,
          backgroundColor: "#ffffff",
          boxShadow: "0px -1px 0px #ECECEC",
        }}
      >
        <Button
          size="small"
          variant="secondary"
          onClick={() => {
              // setIsOpenProfileShareModal(true)
            MobileShare(
              "分享接案履歷",
              "",
              `${window.location.origin}/profile/${id}`
            )
          }}
          style={{ marginRight: 8, minWidth: 116 }}
        >
          分享接案履歷
        </Button>
        <Button
          size="small"
          fullWidth
          onClick={() => {
            if (tabValue === 0) {
              setIsOpenAddLinkModal(true)
            } else if(tabValue === 1){
              setIsOpenEditIntroductionModal(true)
            } else {
              setIsOpenEditAchievementModal(true)
            }
          }}
        >
          {tabValue === 0 ? "新增連結" : 
           tabValue === 1 ? "編輯關於我" :
           "管理成就"
          }
        </Button>
      </div>
      <MobileEditButton
        isOpen={isOpenMobileEditButton}
        setIsOpen={setIsOpenMobileEditButton}
        isUpdated
        editButtonContent={[
          {
            text: "編輯聯絡方式",
            icon: icon_email_blue,
            onClick: () => {
              setIsOpenMobileEditButton(false)
              setIsOpenEditContactModal(true)
            },
          },
          {
            text: "編輯個人資料",
            icon: icon_avatar,
            onClick: () => {
              setIsOpenMobileEditButton(false)
              setIsOpenEditProfileModal(true)
            },
          },
          {
            text: "編輯封面圖片",
            icon: icon_photo_blue,
            onClick: () => {
              setIsOpenMobileEditButton(false)
              setIsOpenEditCoverMobileModal(true)
            },
          },
        ]}
      />
    </>
  )
}


interface RenderAchievementModalProps {
  isMobile : boolean
  isFullWidth : boolean
  isOpen : boolean
  onCloseModal :  ()=> void
  onSaveComplete: ()=> void
}

const RenderAchievementModal = ( {isMobile, isFullWidth, isOpen, onCloseModal, onSaveComplete} : RenderAchievementModalProps ) => {

  const classes = useStyles();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [tempVisibilityChanges, setTempVisibilityChanges] = useState<{[key: string]: boolean}>({});
  const [achievements, setAchievements] = useState<AchievementProps[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      fetchAchievements();
    }
  }, [isOpen]);

  const applyVisibilityChanges = async () => {
    try {
      if((Object.keys(tempVisibilityChanges).length !== 0)){
        const promises = Object.entries(tempVisibilityChanges).map(([id]) => 
          toggleAchievementVisibleFromSOHO(id)
        );
        await Promise.all(promises);
        setTempVisibilityChanges({});
        await fetchAchievements();
        setIsModalOpen(false);
        onSaveComplete();
      } else{
        setIsModalOpen(false);
        onSaveComplete();
      }
    } catch (error) {
      console.error("Error updating achievements visibility:", error);
    }
  };

  const fetchAchievements = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getPersonalAchievementsFromSOHO();

      if (result && result.status === "200" && result.errors === null) {
        setAchievements(result.payload);
        return result.payload;
      } else {
        throw result.errors || new Error("Failed to fetch achievements");
      }
    } catch (error) {
      console.log("Error fetching achievements:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleToggleVisibility = (achievementId: string, currentVisibility: boolean) => {
    setTempVisibilityChanges(prev => ({
      ...prev,
      [achievementId]: !currentVisibility
    }));
  };

  const acquiredAchievements = achievements.filter(a => a.personal_achievement !== null);

  const renderStars = (percentage: number) => {
    if (percentage <= 25) {
      return 4;
    } else if (percentage <= 50) {
      return 3;
    } else if (percentage <= 75) {
      return 2;
    } else {
      return 1;
    }
  };

  const getAchievementShadowClass = (type: string) => {
    let shadowClass = classes.achievementShadow;
    if (type.startsWith("operation")) {
      shadowClass += ` ${classes.operationShadow}`;
    } else if (type.startsWith("payment")) {
      shadowClass += ` ${classes.paymentShadow}`;
    } else if (type.startsWith("community")) {
      shadowClass += ` ${classes.communityShadow}`;
    }
    return shadowClass;
  };

  if (loading) {
    return <CenterLoading />;
  }

  return ( 
  <Modal
    mobile={isMobile}
    fullWidth={isFullWidth}
    open={isModalOpen}
    maxWidth={isMobile ? undefined : 640}
    onClose={() => {
      setIsModalOpen(false);
      setTempVisibilityChanges({});
      onCloseModal();
    }}
    title="管理成就"
    size="large"
    primaryButton={{
      title : "完成",
      onClick: applyVisibilityChanges,
    }}
    secondaryButton={{
      title : "取消",
      onClick: () => {
        setIsModalOpen(false);
        setTempVisibilityChanges({});
        onCloseModal();
      },
    }}
  >
    <Grid container spacing={2}>
      {acquiredAchievements.length === 0 && 
        <Typography variant="body1">No acquired achievements.</Typography>
      }
      {acquiredAchievements.map((achievement) => {
        const achievementId = achievement.personal_achievement?.id || "";
        const isVisible = tempVisibilityChanges.hasOwnProperty(achievementId)
          ? tempVisibilityChanges[achievementId]
          : achievement.personal_achievement?.is_visible || false;

        const starCount = renderStars(achievement.percentage);

          return (
        <Grid item xs={12} key={achievement.id}>
          <div className={classes.achievementItem}>
            <div className={classes.achievementImageWrapper}>
              <div style={{ display: "flex", 
                            flexDirection: "column", 
                            alignItems: "center", 
                            justifyContent: "center" }}>
               <div className={`${classes.achievementShadow} ${getAchievementShadowClass(achievement.type)}`}></div>
                <img
                  alt={`${achievement.name} achievement icon`}
                  className={classes.achievementImage}
                  src={achievement.picture_url}
                />
                <div style={{ marginTop: 16,
                              display: "flex", 
                              justifyContent: "center", 
                              gap: "4px" }}>
                {Array.from({ length: starCount }, (_, index) => (
                    <img 
                      key={index}
                      style={{ width: 16, height: 16 }}
                      src="https://swap-img.swap.work/achievement/Star@2x.png"
                      alt="star-image"
                    />
                ))}
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
              <Typography variant="title">{achievement.name}</Typography>
              <SWAPSpace size="xxs" />
              <Typography variant="body2">{achievement.subtitle}</Typography>
            </div>
            <Switch
                checked={isVisible}
                onChange={() => handleToggleVisibility(achievementId, isVisible)}
                focusVisibleClassName={classes.focusVisible}
                focusRipple
                TouchRippleProps={{
                  center: true,
                }}
                aria-label={`Toggle visibility for ${achievement.name}`}
              />
          </div>
        </Grid>
        );
        })}
    </Grid>
  </Modal>
  )
};

/**元件區 */
export interface AvatarProps {
  avatar: string
  avatarForBase64?: string
  memberData?: MemberDataProps
  width?: number | string
  height?: number | string
  borderRadius?: number | string
}

export const Avatar = ({
  avatar,
  avatarForBase64,
  memberData,
  width,
  height,
  borderRadius,
}: AvatarProps) => {
  return avatar ? (
    <div
      style={{
        minWidth: width ? width : 108,
        width: width ? width : 108,
        height: height ? height : 108,
        borderRadius: borderRadius ? borderRadius : 36,
        backgroundImage: `url("${avatarForBase64 || avatar}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "50% 50%",
      }}
    ></div>
  ) : memberData ? (
    <EmptyAvatar
      memberData={{ name: memberData.verified_name, email: memberData.email }}
    />
  ) : null
}

export interface NameProps {
  name: string
  isMobile?: boolean
}

const Name = ({ name, isMobile }: NameProps) => {
  return (
    <Typography
      variant="h4"
      style={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: isMobile ? 1 : 2,
        WebkitBoxOrient: "vertical",
        wordBreak: "break-all",
        marginRight: 8,
      }}
    >
      {name}
    </Typography>
  )
}

export interface IntroductionProps {
  introduction: string
  isFromGuest?: boolean
}

const Introduction = ({ introduction, isFromGuest }: IntroductionProps) => {
  return isFromGuest && !introduction ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 52,
      }}
    >
      <img
        alt="swap-no-intro"
        src="https://swap-img.swap.work/media/profile/nointroduction.svg"
        height={142}
      />
      <SWAPSpace size={26} />
      <Typography variant="body2" color="black800">
        目前尚無簡介
      </Typography>
    </div>
  ) : (
    <Typography
      variant="body2_loose"
      color="black800"
      style={{ whiteSpace: "pre-line", wordBreak: "break-all" }}
    >
      {introduction}
    </Typography>
  )
}
export interface ChipProps {
  workType: string
  caseType: CaseTypeProps | ""
  seniority: SeniorityProps | ""
  isMobile?: boolean
}

export const Chip = ({
  workType,
  caseType,
  seniority,
  isMobile,
}: ChipProps) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {[
        {
          display: Boolean(workType),
          label: workType === "personal" ? "個人接案" : "團隊接案",
        },
        {
          display: Boolean(caseType),
          label: caseType,
        },
        {
          display: Boolean(seniority),
          label: seniority,
        },
      ].map((i, index) => {
        if (!i.display) return
        return (
          <div
            key={index}
            style={{
              width: 64,
              height: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 4,
              backgroundColor: "#f2f2f2",
              fontSize: 12,
              fontWeight: 700,
              margin: isMobile ? "0 6px" : "0 8px 0 0",
            }}
          >
            {i.label}
          </div>
        )
      })}
    </div>
  )
}

export interface VerifyIconProps {
  verifiedState: string
  isPreview?: boolean
  isMobile?: boolean
}

const VerifyIcon = ({
  verifiedState,
  isPreview,
  isMobile,
}: VerifyIconProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  return verifiedState === "CONFIRM" ? (
    <div
      className="verified_wrap"
      onClick={() => {
        setTooltipOpen(!tooltipOpen)
      }}
    >
      <Tooltip
        title="已通過 SWAP 實名認證！"
        style={{ zIndex: 1 }}
        {...(isMobile
          ? {
              arrow: true,
              placement: "top",
              open: tooltipOpen,
              disableFocusListener: true,
              disableHoverListener: true,
              disableTouchListener: true,
            }
          : {
              arrow: true,
              placement: "top",
            })}
      >
        {icon_verified(isMobile)}
      </Tooltip>
    </div>
  ) : (
    <div
      style={{
        cursor: isPreview ? undefined : "pointer",
      }}
      onClick={() => {
        if (!isPreview) {
          window.location.href = PathAndTitle.member.settings.path
        }
      }}
    >
      <Tooltip title="尚未完成 SWAP 實名認證" arrow placement="top">
        {icon_unVerified(isMobile)}
      </Tooltip>
    </div>
  )
}

export interface ContactComponentProps {
  contact: ContactProps
  isMobile?: boolean
}

const ContactComponent = ({ contact, isMobile }: ContactComponentProps) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {[
        {
          icon: contact.email.link ? icon_email : undefined,
          link: `mailto:${contact.email.link}`,
        },
        {
          icon: contact.facebook.link ? icon_facebook : undefined,
          link: contact.facebook.link,
        },
        {
          icon: contact.instagram.link ? icon_ig : undefined,
          link:
            contact.instagram.link.indexOf("instagram.com") === -1
              ? `https://www.instagram.com/${contact.instagram.link}`
              : contact.instagram.link,
        },
        {
          icon: contact.linkedin.link ? icon_linkedin : undefined,
          link: contact.linkedin.link,
        },
      ].map((i, index) => {
        if (!i.icon) return
        return (
          <div
            key={index}
            style={{
              width: 40,
              height: 40,
              backgroundColor: "#f6f6f6",
              borderRadius: 8,
              margin: isMobile ? "0 8px" : "0 16px 0 0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              window.open(
                i.link.indexOf("http") === -1 &&
                  i.link.indexOf("mailto:") === -1
                  ? `https://${i.link}`
                  : i.link
              )
            }}
          >
            {i.icon}
          </div>
        )
      })}
    </div>
  )
}

export interface EmptyAvatarProps {
  memberData: { name: string; email: string }
}

export const EmptyAvatar = ({ memberData }: EmptyAvatarProps) => {
  return (
    <div
      style={{
        height: 108,
        width: 108,
        border: " 1px solid #2D2D2D",
        borderRadius: 36,
        backgroundColor: "#FFFFFF",
        padding: 1,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 36,
          backgroundColor: "#2D2D2D",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h1" style={{ color: "#FFFFFF" }}>
          {memberData?.name
            ? memberData.name[0].toLocaleUpperCase()
            : memberData?.email
            ? memberData.email[0].toLocaleUpperCase()
            : "-"}
        </Typography>
      </div>
    </div>
  )
}

export default Profile

// const icon_verified = (isMobile?: boolean) => {
//   return (
//     <svg
//       width="40"
//       height="39"
//       viewBox="0 0 40 39"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       style={{
//         width: isMobile ? 24 : undefined,
//         height: isMobile ? 24 : undefined,
//         display: "block",
//       }}
//     >
//       <g filter="url(#filter0_d_440_10941)">
//         <path
//           d="M19.7899 2.45814C19.9225 2.39359 20.0775 2.39359 20.2101 2.45814L21.9934 3.32616C22.1936 3.42357 22.4182 3.45914 22.6386 3.42834L24.6029 3.1539C24.749 3.13349 24.8963 3.18136 25.0025 3.28373L26.4303 4.66036C26.5906 4.81484 26.7932 4.91807 27.0123 4.9569L28.9653 5.3029C29.1105 5.32862 29.2359 5.41968 29.3052 5.54985L30.2378 7.30034C30.3424 7.49676 30.5032 7.65756 30.6997 7.7622L32.4502 8.69477C32.5803 8.76412 32.6714 8.88945 32.6971 9.03467L33.0431 10.9877C33.0819 11.2068 33.1852 11.4094 33.3396 11.5697L34.7163 12.9975C34.8186 13.1037 34.8665 13.251 34.8461 13.3971L34.5717 15.3614C34.5409 15.5818 34.5764 15.8064 34.6738 16.0066L35.5419 17.7899C35.6064 17.9225 35.6064 18.0775 35.5419 18.2101L34.6738 19.9934C34.5764 20.1936 34.5409 20.4182 34.5717 20.6386L34.8461 22.6029C34.8665 22.749 34.8186 22.8963 34.7163 23.0025L33.3396 24.4303C33.1852 24.5906 33.0819 24.7932 33.0431 25.0123L32.6971 26.9653C32.6714 27.1105 32.5803 27.2359 32.4502 27.3052L30.6997 28.2378C30.5032 28.3424 30.3424 28.5032 30.2378 28.6997L29.3052 30.4502C29.2359 30.5803 29.1105 30.6714 28.9653 30.6971L27.0123 31.0431C26.7932 31.0819 26.5906 31.1852 26.4303 31.3396L25.0025 32.7163C24.8963 32.8186 24.749 32.8665 24.6029 32.8461L22.6386 32.5717C22.4182 32.5409 22.1936 32.5764 21.9934 32.6738L20.2101 33.5419C20.0775 33.6064 19.9225 33.6064 19.7899 33.5419L18.0066 32.6738C17.8064 32.5764 17.5818 32.5409 17.3614 32.5717L15.3971 32.8461C15.251 32.8665 15.1037 32.8186 14.9975 32.7163L13.5697 31.3396C13.4094 31.1852 13.2068 31.0819 12.9877 31.0431L11.0347 30.6971C10.8895 30.6714 10.7641 30.5803 10.6948 30.4502L9.7622 28.6997C9.65756 28.5032 9.49676 28.3424 9.30034 28.2378L7.54985 27.3052C7.41968 27.2359 7.32862 27.1105 7.30289 26.9653L6.9569 25.0123C6.91807 24.7932 6.81484 24.5906 6.66036 24.4303L5.28373 23.0025C5.18136 22.8963 5.13349 22.749 5.1539 22.6029L5.42834 20.6386C5.45914 20.4182 5.42357 20.1936 5.32616 19.9934L4.45814 18.2101C4.39359 18.0775 4.39359 17.9225 4.45814 17.7899L5.32616 16.0066C5.42357 15.8064 5.45914 15.5818 5.42834 15.3614L5.1539 13.3971C5.13349 13.251 5.18136 13.1037 5.28373 12.9975L6.66036 11.5697C6.81484 11.4094 6.91807 11.2068 6.9569 10.9877L7.3029 9.03467C7.32862 8.88945 7.41968 8.76412 7.54985 8.69477L9.30034 7.7622C9.49676 7.65756 9.65756 7.49676 9.7622 7.30034L10.6948 5.54985C10.7641 5.41968 10.8895 5.32862 11.0347 5.3029L12.9877 4.9569C13.2068 4.91807 13.4094 4.81484 13.5697 4.66036L14.9975 3.28373C15.1037 3.18136 15.251 3.13349 15.3971 3.1539L17.3614 3.42834C17.5818 3.45914 17.8064 3.42357 18.0066 3.32616L19.7899 2.45814Z"
//           fill="#3555D5"
//           stroke="#F7B52C"
//           strokeWidth="0.64"
//         />
//         <circle
//           cx="20"
//           cy="18.0002"
//           r="12.48"
//           stroke="#C1C7ED"
//           strokeWidth="0.64"
//         />
//         <path
//           fillRule="evenodd"
//           clipRule="evenodd"
//           d="M26.699 14.2343C27.0114 14.5467 27.0114 15.0533 26.699 15.3657L19.3656 22.699C19.0532 23.0114 18.5467 23.0114 18.2343 22.699L14.9009 19.3657C14.5885 19.0533 14.5885 18.5467 14.9009 18.2343C15.2134 17.9219 15.7199 17.9219 16.0323 18.2343L18.8 21.002L25.5676 14.2343C25.88 13.9219 26.3866 13.9219 26.699 14.2343Z"
//           fill="white"
//         />
//       </g>
//       <defs>
//         <filter
//           id="filter0_d_440_10941"
//           x="0.8"
//           y="0.4"
//           width="38.4"
//           height="38.4"
//           filterUnits="userSpaceOnUse"
//           colorInterpolationFilters="sRGB"
//         >
//           <feFlood floodOpacity="0" result="BackgroundImageFix" />
//           <feColorMatrix
//             in="SourceAlpha"
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//             result="hardAlpha"
//           />
//           <feOffset dy="1.6" />
//           <feGaussianBlur stdDeviation="1.6" />
//           <feColorMatrix
//             type="matrix"
//             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
//           />
//           <feBlend
//             mode="normal"
//             in2="BackgroundImageFix"
//             result="effect1_dropShadow_440_10941"
//           />
//           <feBlend
//             mode="normal"
//             in="SourceGraphic"
//             in2="effect1_dropShadow_440_10941"
//             result="shape"
//           />
//         </filter>
//       </defs>
//     </svg>
//   )
// }

// const icon_unVerified = (isMobile?: boolean) => {
//   return (
//     <svg
//       width="32"
//       height="32"
//       viewBox="0 0 32 32"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       style={{
//         width: isMobile ? 24 : undefined,
//         height: isMobile ? 24 : undefined,
//       }}
//     >
//       <circle
//         cx="16"
//         cy="16.0002"
//         r="12.8"
//         stroke="#909090"
//         strokeWidth="0.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeDasharray="4.8 3.2"
//       />
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M22.699 12.2343C23.0114 12.5467 23.0114 13.0533 22.699 13.3657L15.3656 20.699C15.0532 21.0114 14.5467 21.0114 14.2343 20.699L10.9009 17.3657C10.5885 17.0533 10.5885 16.5467 10.9009 16.2343C11.2134 15.9219 11.7199 15.9219 12.0323 16.2343L14.8 19.002L21.5676 12.2343C21.88 11.9219 22.3866 11.9219 22.699 12.2343Z"
//         fill="#909090"
//       />
//     </svg>
//   )
// }

// const icon_edit = (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M4.16667 2.5C3.24167 2.5 2.5 3.24167 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V10H15.8333V15.8333H4.16667V4.16667H10V2.5H4.16667ZM14.8167 3.33333C14.675 3.33333 14.525 3.39167 14.4167 3.5L13.4 4.50833L15.4833 6.59167L16.5 5.58333C16.7167 5.36667 16.7167 5 16.5 4.79167L15.2083 3.5C15.1 3.39167 14.9583 3.33333 14.8167 3.33333ZM12.8083 5.1L6.66667 11.25V13.3333H8.75L14.8917 7.18333L12.8083 5.1Z"
//       fill="#4862CC"
//     />
//   </svg>
// )

// const icon_email = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M5 5.75C4.30964 5.75 3.75 6.30964 3.75 7V17C3.75 17.6904 4.30964 18.25 5 18.25H19C19.6904 18.25 20.25 17.6904 20.25 17V7C20.25 6.30964 19.6904 5.75 19 5.75H5ZM2.25 7C2.25 5.48122 3.48122 4.25 5 4.25H19C20.5188 4.25 21.75 5.48122 21.75 7V17C21.75 18.5188 20.5188 19.75 19 19.75H5C3.48122 19.75 2.25 18.5188 2.25 17V7Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M2.37592 6.58405C2.60568 6.23941 3.07134 6.14628 3.41598 6.37604L12 12.0987L20.5839 6.37604C20.9286 6.14628 21.3942 6.23941 21.624 6.58405C21.8538 6.9287 21.7606 7.39435 21.416 7.62412L12.416 13.6241C12.1641 13.7921 11.8359 13.7921 11.5839 13.6241L2.58393 7.62412C2.23929 7.39435 2.14616 6.9287 2.37592 6.58405Z"
//       fill="#909090"
//     />
//   </svg>
// )

// const icon_pic = (
//   <svg
//     width="48"
//     height="48"
//     viewBox="0 0 48 48"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M38 38H10V10H38V38ZM38 6H10C8.93913 6 7.92172 6.42143 7.17157 7.17157C6.42143 7.92172 6 8.93913 6 10V38C6 39.0609 6.42143 40.0783 7.17157 40.8284C7.92172 41.5786 8.93913 42 10 42H38C39.0609 42 40.0783 41.5786 40.8284 40.8284C41.5786 40.0783 42 39.0609 42 38V10C42 8.93913 41.5786 7.92172 40.8284 7.17157C40.0783 6.42143 39.0609 6 38 6ZM27.92 24.58L22.42 31.66L18.5 26.94L13 34H35L27.92 24.58Z"
//       fill="#CCCCCC"
//     />
//   </svg>
// )

// const icon_check = (
//   <svg
//     width="16"
//     height="12"
//     viewBox="0 0 16 12"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M15.5 1.83336L5.49999 11.8334L0.916656 7.25002L2.09166 6.07502L5.49999 9.47502L14.325 0.658356L15.5 1.83336Z"
//       fill="#4862CC"
//     />
//   </svg>
// )

// const icon_facebook = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M10.9341 3.93414C12.0125 2.8558 13.475 2.25 15 2.25H18C18.4142 2.25 18.75 2.58579 18.75 3V7C18.75 7.41421 18.4142 7.75 18 7.75H15C14.9337 7.75 14.8701 7.77634 14.8232 7.82322C14.7763 7.87011 14.75 7.9337 14.75 8V9.25H18C18.231 9.25 18.449 9.3564 18.5912 9.53844C18.7333 9.72048 18.7836 9.95785 18.7276 10.1819L17.7276 14.1819C17.6441 14.5158 17.3442 14.75 17 14.75H14.75V21C14.75 21.4142 14.4142 21.75 14 21.75H10C9.58579 21.75 9.25 21.4142 9.25 21V14.75H7C6.58579 14.75 6.25 14.4142 6.25 14V10C6.25 9.58579 6.58579 9.25 7 9.25H9.25V8C9.25 6.47501 9.8558 5.01247 10.9341 3.93414ZM15 3.75C13.8728 3.75 12.7918 4.19777 11.9948 4.9948C11.1978 5.79183 10.75 6.87283 10.75 8V10C10.75 10.4142 10.4142 10.75 10 10.75H7.75V13.25H10C10.4142 13.25 10.75 13.5858 10.75 14V20.25H13.25V14C13.25 13.5858 13.5858 13.25 14 13.25H16.4144L17.0394 10.75H14C13.5858 10.75 13.25 10.4142 13.25 10V8C13.25 7.53587 13.4344 7.09075 13.7626 6.76256C14.0908 6.43438 14.5359 6.25 15 6.25H17.25V3.75H15Z"
//       fill="#909090"
//     />
//   </svg>
// )

// const icon_ig = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8V16C4.75 17.7949 6.20507 19.25 8 19.25H16C17.7949 19.25 19.25 17.7949 19.25 16V8C19.25 6.20507 17.7949 4.75 16 4.75H8ZM3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75ZM8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M16.5 6.75C16.9142 6.75 17.25 7.08579 17.25 7.5V7.50055C17.25 7.91476 16.9142 8.25055 16.5 8.25055C16.0858 8.25055 15.75 7.91476 15.75 7.50055V7.5C15.75 7.08579 16.0858 6.75 16.5 6.75Z"
//       fill="#909090"
//     />
//   </svg>
// )

// const icon_linkedin = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M6 4.75C5.30964 4.75 4.75 5.30964 4.75 6V18C4.75 18.6904 5.30964 19.25 6 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V6C19.25 5.30964 18.6904 4.75 18 4.75H6ZM3.25 6C3.25 4.48122 4.48122 3.25 6 3.25H18C19.5188 3.25 20.75 4.48122 20.75 6V18C20.75 19.5188 19.5188 20.75 18 20.75H6C4.48122 20.75 3.25 19.5188 3.25 18V6Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M8 10.25C8.41421 10.25 8.75 10.5858 8.75 11V16C8.75 16.4142 8.41421 16.75 8 16.75C7.58579 16.75 7.25 16.4142 7.25 16V11C7.25 10.5858 7.58579 10.25 8 10.25Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M8 7.25C8.41421 7.25 8.75 7.58579 8.75 8V8.01C8.75 8.42421 8.41421 8.76 8 8.76C7.58579 8.76 7.25 8.42421 7.25 8.01V8C7.25 7.58579 7.58579 7.25 8 7.25Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V11C11.25 10.5858 11.5858 10.25 12 10.25Z"
//       fill="#909090"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M12.0555 11.0555C12.5712 10.5397 13.2707 10.25 14 10.25C14.7293 10.25 15.4288 10.5397 15.9445 11.0555C16.4603 11.5712 16.75 12.2707 16.75 13V16C16.75 16.4142 16.4142 16.75 16 16.75C15.5858 16.75 15.25 16.4142 15.25 16V13C15.25 12.6685 15.1183 12.3505 14.8839 12.1161C14.6495 11.8817 14.3315 11.75 14 11.75C13.6685 11.75 13.3505 11.8817 13.1161 12.1161C12.8817 12.3505 12.75 12.6685 12.75 13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13C11.25 12.2707 11.5397 11.5712 12.0555 11.0555Z"
//       fill="#909090"
//     />
//   </svg>
// )

// const icon_email_blue = (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M18.3333 5.00065C18.3333 4.08398 17.5833 3.33398 16.6666 3.33398H3.33329C2.41663 3.33398 1.66663 4.08398 1.66663 5.00065V15.0007C1.66663 15.9173 2.41663 16.6673 3.33329 16.6673H16.6666C17.5833 16.6673 18.3333 15.9173 18.3333 15.0007V5.00065ZM16.6666 5.00065L9.99996 9.16732L3.33329 5.00065H16.6666ZM16.6666 15.0007H3.33329V6.66732L9.99996 10.834L16.6666 6.66732V15.0007Z"
//       fill="#4862CC"
//     />
//   </svg>
// )

// const icon_photo_blue = (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM15.8333 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V4.16667C17.5 3.72464 17.3244 3.30072 17.0118 2.98816C16.6993 2.67559 16.2754 2.5 15.8333 2.5ZM11.6333 10.2417L9.34167 13.1917L7.70833 11.225L5.41667 14.1667H14.5833L11.6333 10.2417Z"
//       fill="#4862CC"
//     />
//   </svg>
// )

// const icon_avatar = (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M9.99996 1.66602C5.39996 1.66602 1.66663 5.39935 1.66663 9.99935C1.66663 14.5993 5.39996 18.3327 9.99996 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 9.99996 1.66602ZM5.89163 15.2327C6.24996 14.4827 8.43329 13.7493 9.99996 13.7493C11.5666 13.7493 13.7583 14.4827 14.1083 15.2327C12.975 16.1327 11.55 16.666 9.99996 16.666C8.44996 16.666 7.02496 16.1327 5.89163 15.2327ZM15.3 14.0243C14.1083 12.5743 11.2166 12.0827 9.99996 12.0827C8.78329 12.0827 5.89163 12.5743 4.69996 14.0243C3.84996 12.9077 3.33329 11.516 3.33329 9.99935C3.33329 6.32435 6.32496 3.33268 9.99996 3.33268C13.675 3.33268 16.6666 6.32435 16.6666 9.99935C16.6666 11.516 16.15 12.9077 15.3 14.0243ZM9.99996 4.99935C8.38329 4.99935 7.08329 6.29935 7.08329 7.91602C7.08329 9.53268 8.38329 10.8327 9.99996 10.8327C11.6166 10.8327 12.9166 9.53268 12.9166 7.91602C12.9166 6.29935 11.6166 4.99935 9.99996 4.99935ZM9.99996 9.16602C9.30829 9.16602 8.74996 8.60768 8.74996 7.91602C8.74996 7.22435 9.30829 6.66602 9.99996 6.66602C10.6916 6.66602 11.25 7.22435 11.25 7.91602C11.25 8.60768 10.6916 9.16602 9.99996 9.16602Z"
//       fill="#4862CC"
//     />
//   </svg>
// )

// const icon_arrow = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path d="M7 10L12 15L17 10H7Z" fill="black" />
//   </svg>
// )

// const icon_photo_small = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M19 19H5V5H19V19ZM19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3ZM13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H17.5L13.96 12.29Z"
//       fill="#6F6F6F"
//     />
//   </svg>
// )

// const icon_delete_big = (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M9 3V4H4V6H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z"
//       fill="#6F6F6F"
//     />
//   </svg>
// )

// const icon_close = (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//   >
//     <path
//       d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
//       fill="black"
//     />
//   </svg>
// )